import { DateSelectionType } from 'beesoft-components';
import type { Control } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { OdinDateTimeProps } from './date-time.component';
import OdinDateTime from './date-time.component';

export interface HfDateTimeProps extends OdinDateTimeProps {
  control: Control;
  name: string;
}

export default function HfDateTime({
  control,
  name,
  label,
  readOnly,
  required,
  currentTimeBtn,
  onChange,
  fieldValueConverter,
  disabled,
  fieldValidations,
  labelStyles,
  registerPostSubmitHandler,
}: HfDateTimeProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange: handleChange, value }, fieldState: { error } }) => {
        return (
          <OdinDateTime
            label={label}
            value={value}
            error={error?.message}
            currentTimeBtn={currentTimeBtn}
            fieldValidations={fieldValidations}
            onChange={handleChange}
            dateSelectionType={DateSelectionType.DateOnly}
            readOnly={readOnly}
            required={required}
            disabled={disabled}
            labelStyles={labelStyles}
            registerPostSubmitHandler={registerPostSubmitHandler}
          />
        );
      }}
    />
  );
}
